export default "__VITE_ASSET__cNDlKPJ6__"